import React from "react";
import { useState, useEffect } from "react";

import { Modal, Input, Button, Form, Checkbox, message, Select } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";

import {
  GetEntriesForEvent,
  GetSchools,
  UpdateSubstitutions,
  GetAllSubstitutions,
  GetStudentEventsWithRoles,
} from "../../APIManager";

import { ListOfEvents } from "../../constants";

import styles from "./Substitutions.module.css";
import { findArgsFromCli } from "@craco/craco/lib/args";

const { confirm } = Modal;
const { Option } = Select;

export default function Substitutions({}) {
  const [enrtries, SetEntries] = useState([]);
  const [schools, SetSchools] = useState([]);
  const [selectedEvent, SetSelectedEvent] = useState("");
  const [selectedSchool, SetSelectedSchool] = useState("");
  const [awaitingResponse, SetAwaitingResponse] = useState(true);
  const [allSubstitutions, SetAllSubstitutions] = useState([]);
  const [loadingAllSubs, SetLoadingAllSubs] = useState(true);

  useEffect(() => {
    if (selectedEvent) {
      SetAwaitingResponse(true);
      SetSelectedSchool("");
      GetEntriesForEvent(selectedEvent).then((Res) => {
        SetEntries(Res.data);
        SetAwaitingResponse(false);
      });
    }
  }, [selectedEvent]);

  useEffect(() => {
    GetSchools().then((Res) => {
      SetSchools(Res.data);
    });
    fetchAllSubstitutions();
  }, []);

  function fetchAllSubstitutions() {
    SetLoadingAllSubs(true);
    GetAllSubstitutions()
      .then((Res) => {
        SetAllSubstitutions(Res.data);
        SetLoadingAllSubs(false);
      })
      .catch(() => {
        SetLoadingAllSubs(false);
      });
  }
  function GetSchool(id) {
    return schools.filter((s) => s._id == id)[0];
  }

  function RefreshEntries() {
    GetEntriesForEvent(selectedEvent).then((Res) => {
      SetEntries(Res.data);
      SetAwaitingResponse(false);
    });
    fetchAllSubstitutions();
  }

  // Filter entries that have active substitutions
  const entriesWithActiveSubs = allSubstitutions.filter(
    (entry) => entry.Substitutions && entry.Substitutions.length > 0,
  );

  return (
    <div>
      <h1>Substitutions</h1>

      {/* Active Substitutions Section */}
      <div className={styles.ActiveSubsSection}>
        <h2>Active Substitutions</h2>
        {loadingAllSubs ? (
          <p>Loading...</p>
        ) : entriesWithActiveSubs.length === 0 ? (
          <p>No active substitutions</p>
        ) : (
          <div className={styles.ActiveSubsList}>
            {entriesWithActiveSubs.map((entry) => (
              <div key={entry._id} className={styles.ActiveSubCard}>
                <div className={styles.ActiveSubHeader}>
                  <strong>{entry.RaceName}</strong>
                  <span className={styles.SchoolBadge}>
                    {entry.Team?.schoolname || "Unknown School"}
                  </span>
                </div>
                <div className={styles.SubDetails}>
                  {entry.Substitutions.map((sub, idx) => (
                    <div key={idx} className={styles.SubRow}>
                      <span className={styles.OriginalRower}>
                        {sub.OriginalRowerName}
                      </span>
                      <span className={styles.Arrow}>→</span>
                      <span className={styles.SubstituteRower}>
                        {sub.SubstituteRowerName}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      <hr className={styles.Divider} />

      {/* Manage Substitutions Section */}
      <h2>Manage Substitutions</h2>
      <div>
        <h1>Select a race</h1>
        <Select
          showSearch
          value={selectedEvent}
          placeholder="Select a Race"
          filterOption={(input, option) =>
            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
          allowClear
          style={{ width: "50ch" }}
          onChange={(e) => {
            SetSelectedEvent(e);
          }}
        >
          {ListOfEvents.map(function (item, i) {
            return <Option value={item}>{item}</Option>;
          })}
        </Select>
      </div>
      <br />
      {selectedEvent && !awaitingResponse && (
        <div>
          <h1>Select a school</h1>
          <Select
            showSearch
            value={selectedSchool}
            placeholder="Select a Race"
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
            allowClear
            style={{ width: "50ch" }}
            onChange={(e) => {
              SetSelectedSchool(e);
            }}
          >
            {enrtries.map(function (item, i) {
              console.log(enrtries);
              return (
                <Option value={item.Team}>
                  {GetSchool(item.Team).schoolname}
                </Option>
              );
            })}
          </Select>
        </div>
      )}
      {selectedEvent && !awaitingResponse && selectedSchool && (
        <div>
          <h1>Subs:</h1>{" "}
          <SubSelectComponent
            school={GetSchool(selectedSchool)}
            entry={enrtries.filter((e) => e.Team == selectedSchool)[0]}
            eventClass={
              enrtries.filter((e) => e.Team == selectedSchool)[0]?.Class
            }
            allSubstitutions={allSubstitutions}
            OnConfirm={(subs) => {
              UpdateSubstitutions({
                EventName: selectedEvent,
                SchoolID: selectedSchool,
                Subs: subs,
              }).then((res) => {
                message.success("Subs Updated");
                SetSelectedSchool("");
                RefreshEntries();
              });
            }}
            key={`${selectedEvent}-${selectedSchool}`}
          />
        </div>
      )}
    </div>
  );
}

const SubSelectComponent = ({
  school,
  entry,
  eventClass,
  allSubstitutions,
  OnConfirm,
}) => {
  const [subs, SetSubs] = useState(entry.Substitutions);
  const [subEventsInfo, SetSubEventsInfo] = useState({}); // { subId: { loading, entries } }

  console.log("Entry data:", entry);
  console.log("SubRowers:", entry.SubRowers);
  console.log("SubCoxers:", entry.SubCoxers);

  var repeatSubs = CheckRepeatSubs(subs);

  const fetchSubEvents = (subId) => {
    if (!subId || subEventsInfo[subId]) return;

    SetSubEventsInfo((prev) => ({
      ...prev,
      [subId]: { loading: true, entries: [] },
    }));

    GetStudentEventsWithRoles(subId)
      .then((res) => {
        SetSubEventsInfo((prev) => ({
          ...prev,
          [subId]: { loading: false, entries: res.data.Entries || [] },
        }));
      })
      .catch(() => {
        SetSubEventsInfo((prev) => ({
          ...prev,
          [subId]: { loading: false, entries: [] },
        }));
      });
  };

  const getSubName = (subId, isRower = true) => {
    const list = isRower ? entry.SubRowers : entry.SubCoxers;
    const sub = list.find((s) => s._id === subId);
    return sub ? sub.Name : "Unknown";
  };

  return (
    <div>
      {!repeatSubs ? (
        <></>
      ) : (
        <div className={styles.ErrorMessage}>Error: Repeated Substitute(s)</div>
      )}
      {entry.Rowers.map((r) => {
        const selectedSubId = subs.find((s) => s.rID === r._id)?.sID;
        const subInfo = selectedSubId ? subEventsInfo[selectedSubId] : null;

        return (
          <div className={styles.RowerRowContainer} key={r._id}>
            <div className={styles.RowerRow}>
              <label>{r.Name}</label>
              <Select
                value={selectedSubId || null}
                placeholder="Select a Sub"
                allowClear
                style={{ width: "25ch" }}
                onChange={(e) => {
                  var newSubs = [...subs];
                  newSubs = newSubs.filter((s) => s.rID != r._id);
                  if (e) {
                    newSubs.push({ rID: r._id, sID: e });
                    fetchSubEvents(e);
                  }
                  SetSubs(newSubs);
                }}
              >
                {(entry.SubRowers || []).map(function (item, i) {
                  return (
                    <Option key={item._id} value={item._id}>
                      {item.Name}
                    </Option>
                  );
                })}
              </Select>
            </div>
            {selectedSubId && (
              <SubEventsDisplay
                subName={getSubName(selectedSubId, true)}
                subInfo={subInfo}
                subId={selectedSubId}
                allSubstitutions={allSubstitutions}
                newRole="rower"
                newEventClass={eventClass}
              />
            )}
          </div>
        );
      })}
      {entry.Coxers.map((r) => {
        const selectedSubId = subs.find((s) => s.rID === r._id)?.sID;
        const subInfo = selectedSubId ? subEventsInfo[selectedSubId] : null;

        return (
          <div className={styles.RowerRowContainer} key={r._id}>
            <div className={styles.RowerRow}>
              <label>{r.Name}</label>
              <Select
                value={selectedSubId || null}
                placeholder="Select a Sub Cox"
                allowClear
                style={{ width: "25ch" }}
                onChange={(e) => {
                  var newSubs = [...subs];
                  newSubs = newSubs.filter((s) => s.rID != r._id);
                  if (e) {
                    newSubs.push({ rID: r._id, sID: e });
                    fetchSubEvents(e);
                  }
                  SetSubs(newSubs);
                }}
              >
                {(entry.SubCoxers || []).map(function (item, i) {
                  return (
                    <Option key={item._id} value={item._id}>
                      {item.Name}
                    </Option>
                  );
                })}
              </Select>
            </div>
            {selectedSubId && (
              <SubEventsDisplay
                subName={getSubName(selectedSubId, false)}
                subInfo={subInfo}
                subId={selectedSubId}
                allSubstitutions={allSubstitutions}
                newRole="cox"
                newEventClass={eventClass}
              />
            )}
          </div>
        );
      })}
      <Button
        type="primary"
        disabled={repeatSubs}
        onClick={() => {
          OnConfirm(subs);
        }}
      >
        Confirm
      </Button>
    </div>
  );
};

// Helper function to check if a sub was confirmed as playing in a specific event
function isConfirmedAsPlaying(subId, raceName, allSubstitutions) {
  if (!allSubstitutions || !Array.isArray(allSubstitutions)) return false;

  const raceEntry = allSubstitutions.find(
    (entry) => entry.RaceName === raceName,
  );
  if (!raceEntry || !raceEntry.Substitutions) return false;

  return raceEntry.Substitutions.some((sub) => sub.sID === subId);
}

// Validation function based on the rules
function validateSubstitution(
  entries,
  newRole,
  newEventClass,
  subId,
  allSubstitutions,
) {
  // Count current events
  // - "Rower" and "Cox" always count
  // - "Sub Rower" and "Sub Cox" only count if they were confirmed as playing (substituted in)
  const indoorEvents = entries.filter(
    (e) =>
      e.Class === "Indoor Race" &&
      (e.Role === "Rower" ||
        (e.Role === "Sub Rower" &&
          isConfirmedAsPlaying(subId, e.RaceName, allSubstitutions))),
  ).length;
  const rowingEvents = entries.filter(
    (e) =>
      e.Class === "Water Race" &&
      (e.Role === "Rower" ||
        (e.Role === "Sub Rower" &&
          isConfirmedAsPlaying(subId, e.RaceName, allSubstitutions))),
  ).length;
  const coxEvents = entries.filter(
    (e) =>
      e.Class === "Water Race" &&
      (e.Role === "Cox" ||
        (e.Role === "Sub Cox" &&
          isConfirmedAsPlaying(subId, e.RaceName, allSubstitutions))),
  ).length;

  // After this sub, what would the counts be?
  const newIndoorEvents =
    newEventClass === "Indoor Race" && newRole === "rower"
      ? indoorEvents + 1
      : indoorEvents;
  const newRowingEvents =
    newEventClass === "Water Race" && newRole === "rower"
      ? rowingEvents + 1
      : rowingEvents;
  const newCoxEvents =
    newEventClass === "Water Race" && newRole === "cox"
      ? coxEvents + 1
      : coxEvents;

  if (newRole === "rower") {
    if (newEventClass === "Indoor Race") {
      return newIndoorEvents <= 2
        ? { valid: true }
        : {
            valid: false,
            message: "Can only take part in max two indoor events",
          };
    }
    if (newEventClass === "Water Race") {
      if (coxEvents === 0) {
        return newRowingEvents <= 2
          ? { valid: true }
          : {
              valid: false,
              message: "Can only take part in max two rowing events",
            };
      } else if (coxEvents === 1) {
        return newRowingEvents <= 2
          ? { valid: true }
          : {
              valid: false,
              message: "Can only take part in max two rowing events",
            };
      } else if (coxEvents === 2) {
        return newRowingEvents <= 1
          ? { valid: true }
          : {
              valid: false,
              message:
                "Can only take part in max one rowing event if coxing for 2 events",
            };
      } else if (coxEvents >= 3) {
        return {
          valid: false,
          message: "Can't take part in any rowing event if coxing for 3 events",
        };
      }
    }
  }
  if (newRole === "cox") {
    if (rowingEvents > 1) {
      return newCoxEvents <= 1
        ? { valid: true }
        : {
            valid: false,
            message:
              "Can only take part in max one cox event if taking part in 2 rowing events",
          };
    } else {
      return newCoxEvents <= 3
        ? { valid: true }
        : {
            valid: false,
            message: "Can only take part in max three cox events if not rowing",
          };
    }
  }
  return { valid: true };
}

const SubEventsDisplay = ({
  subName,
  subInfo,
  subId,
  allSubstitutions,
  newRole,
  newEventClass,
}) => {
  if (!subInfo) {
    return <div className={styles.SubEventsLoading}>Loading events...</div>;
  }

  if (subInfo.loading) {
    return <div className={styles.SubEventsLoading}>Loading events...</div>;
  }

  const entries = subInfo.entries;
  const eventCount = entries.length;

  // Validate the substitution
  const validation = validateSubstitution(
    entries,
    newRole,
    newEventClass,
    subId,
    allSubstitutions,
  );

  // Check which sub entries are actively playing
  const getEntryStatus = (entry) => {
    const isSubRole = entry.Role === "Sub Rower" || entry.Role === "Sub Cox";
    if (!isSubRole) return { isActiveSub: false, countsToQuota: true };

    const isActivelySub = isConfirmedAsPlaying(
      subId,
      entry.RaceName,
      allSubstitutions,
    );
    return { isActiveSub: isActivelySub, countsToQuota: isActivelySub };
  };

  return (
    <div
      className={`${styles.SubEventsContainer} ${!validation.valid ? styles.SubEventsError : ""}`}
    >
      {!validation.valid && (
        <div className={styles.ValidationError}>
          ⚠️ <strong>Rule Violation:</strong> {validation.message}
        </div>
      )}
      <div className={styles.SubEventsHeader}>
        <strong>{subName}</strong> is registered in{" "}
        <span
          className={
            eventCount >= 3 ? styles.EventCountWarning : styles.EventCount
          }
        >
          {eventCount} event(s)
        </span>
      </div>
      {entries.length > 0 ? (
        <ul className={styles.SubEventsList}>
          {entries.map((entry, idx) => {
            const status = getEntryStatus(entry);
            const isSubRole =
              entry.Role === "Sub Rower" || entry.Role === "Sub Cox";

            return (
              <li
                key={idx}
                className={`${styles.SubEventItem} ${status.isActiveSub ? styles.ActiveSubEntry : ""}`}
              >
                <span
                  className={`${styles.SubEventRole} ${status.isActiveSub ? styles.ActiveSubRole : ""}`}
                >
                  {entry.Role}
                </span>
                {isSubRole && (
                  <span
                    className={
                      status.isActiveSub
                        ? styles.CountsToQuota
                        : styles.DoesNotCountToQuota
                    }
                  >
                    {status.isActiveSub ? "Playing" : "Not active"}
                  </span>
                )}
                <span className={styles.SubEventName}>{entry.RaceName}</span>
                <span className={styles.SubEventClass}>{entry.Class}</span>
              </li>
            );
          })}
        </ul>
      ) : (
        <p className={styles.NoEvents}>No other events</p>
      )}
    </div>
  );
};

function CheckRepeatSubs(subs) {
  var oSubs = [...subs].map((s) => s.sID);

  return oSubs.length !== new Set(oSubs).size;
}
